module.exports = __webpack_public_path__ + "img/Sleeves-Front-Gd-Ha-Ib.f830f93d.png";